module.exports = "<span class=\"tab-holder\" *ngFor=\"let tab of tabs; let i=index\" [class.small-tab]=\"smallTabs\">\n    <span class=\"tog-tab\" \n          [class.active]=\"i === currentTab\"\n          (click)=\"updateTab(i)\">\n        {{ tab }}\n    </span>\n    <span class=\"divider\" *ngIf=\"!smallTabs\">|</span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/tab-bar/tab-bar.template.html
// module id = ../../../../../src/app/shared/components/tab-bar/tab-bar.template.html
// module chunks = 12